export default "__VITE_ASSET__Bf9gkwvP__"